module.exports = __webpack_public_path__ + "img/shake_button.bf2cfef6.png";